// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

export const INVESTMENT_HOLDINGS_V2_REDUCER_KEY = 'investmentHoldingsV2Store';

type WebSocketQCSStoreType = {
  readyState: ?string,
};
export type WebSocketQCSStore = RecordOf<WebSocketQCSStoreType>;
export const mkWebSocketQCSStore: RecordFactory<WebSocketQCSStoreType> =
  Record({
    readyState: undefined,
  });

type WebSocketQCSMessageType = {
  traceId: ?string,
  eventType: string,
  data: ?any,
};
export type WebSocketQCSMessage = RecordOf<WebSocketQCSMessageType>;
export const mkWebSocketQCSMessage: RecordFactory<WebSocketQCSMessageType> =
  Record({
    traceId: undefined,
    eventType: undefined,
    data: undefined,
  });

